/*
 * @Author: heyouqin@moyi365.com
 * @LastEditors: heyouqin@moyi365.com
 * @Date: 2024-02-21 17:56:05
 * @LastEditTime: 2024-02-21 17:56:43
 * @Descripttion: file content
 */
export const copy = (data: object | any[]) => JSON.parse(JSON.stringify(data))
